import { render, staticRenderFns } from "./GtmPromotionImpressions.vue?vue&type=template&id=553cefb0"
import script from "./GtmPromotionImpressions.vue?vue&type=script&lang=js"
export * from "./GtmPromotionImpressions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports